import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, CancelJobRequestDto } from '../sdk/sdk';

@Injectable({
  providedIn: 'root',
})
export class JobService {
  private readonly sdk = inject(ApiClient);

  cancelJob(jobId: string, cancelledReasonId: string, comment: string): Observable<void> {
    const dto = new CancelJobRequestDto({ cancelledReasonId, comment });
    return this.sdk.cancelJob(jobId, dto);
  }
}
